import { PropsWithChildren, Suspense } from 'react'

import { Loading } from '@avantstay/backoffice-core'

import { Header } from '../Header'
import * as S from './Layout.styles'

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <S.MainContainer>
      <Header />

      <Suspense fallback={<Loading absolute />}>{children}</Suspense>
    </S.MainContainer>
  )
}
